// import pages
import React, { useState, useEffect } from "react";
import FooterB from "../layout/FooterB";
import SubHeader from "../layout/SubHeader";
import SubFooter from "../layout/SubFooter";
import HeroSection from "../layout/HeroSection";
import ArticlesIndexSection from "../layout/ArticlesIndexSection";
import ArticlesSection from "../layout/ArticlesSection";
import { getArticlesPage } from "../../sanityClient";

// import style
import "../../style/pages/articles/articles.scss";

// Component map to render different section types
const componentMap = {
  heroSection: HeroSection,
  indexSection: ArticlesIndexSection,
  articlesSection: ArticlesSection,
  footerB: FooterB,
  subHeader: SubHeader,
  subFooter: SubFooter,
};

const Articles = () => {
  const [pageData, setPageData] = useState({
    pageSections: []
  });
  const [loading, setLoading] = useState(true);
  // Selected tag for the index-section → articles-section filter.
  // null means "show all articles".
  const [selectedTag, setSelectedTag] = useState(null);

  // Toggle behavior: clicking the active tag clears the filter.
  const handleSelectTag = (tag) => {
    setSelectedTag((prev) => (prev === tag ? null : tag));
  };

  useEffect(() => {
    const fetchPageData = async () => {
      try {
        const data = await getArticlesPage();
        if (data) {
          setPageData(data);
        }
      } catch (error) {
        console.error("Error fetching page data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPageData();
  }, []);

  // Render a section based on its type
  const renderSection = (section, index) => {
    const SectionComponent = componentMap[section._type];
    
    if (!SectionComponent) {
      console.warn(`Unknown section type: ${section._type}`);
      return null;
    }

    // Pass the appropriate props based on section type
    switch (section._type) {
      case 'heroSection':
        return (
          <SectionComponent
            key={section._key || index}
            title={section.title}
            subTitle={section.subTitle}
            backgroundColorClass={section.backgroundColorClass}
            linkPath={section.linkPath}
            enContent={section.enContent}
            jpContent={section.jpContent}
            questionLinkText={section.questionLink}
            questionLinkJpText={section.questionLinkJp}
          />
        );
      case 'indexSection':
        return <SectionComponent
          key={section._key || index}
          title={section.title}
          titleJP={section.titleJP}
          subtitles={section.subtitles} // dynamic array of subtitles
          items={section.items}         // dynamic array of items
          bottomText={section.bottomText}
          bottomTextJP={section.bottomTextJP}
          selectedTag={selectedTag}
          onSelectTag={handleSelectTag}
        />;
      case 'articlesSection':
        return <SectionComponent
          key={section._key || index}
          items={section.items}
          selectedTag={selectedTag}
          onClearFilter={() => setSelectedTag(null)}
        />;
      case 'footerB':
        return <SectionComponent 
          key={section._key || index}
          title={section.title}
          backgroundColorClass={section.backgroundColorClass}
        />;
      case 'subHeader':
        return <SectionComponent
          key={section._key || index}
          title={section.title}
          backgroundColorClass={section.backgroundColorClass}
        />;
      case 'subFooter':
        return <SectionComponent
          key={section._key || index}
          title={section.title}
          backgroundColorClass={section.backgroundColorClass}
        />;
      default:
        return null;
    }
  };

  if (loading) {
    return <div>Loading...</div>; // Optional loading state
  }

  return (
    <div className="articles-section">
      {pageData.pageSections && pageData.pageSections.length > 0 ? (
        pageData.pageSections.map((section, index) => renderSection(section, index))
      ) : (
        // Fallback Oops! section
        <>
          <div className="error-container container main-section">
            <div className="responsive-main-section">
              <div className="title-section background-orange">
                <div className="title-link">
                  <div className="title font-amaticsc-bold">Oops!</div>
                  <div className="sub-title font-zenkurenaido">おっと！</div>
                </div>
              </div>
              <div className="content-section">
                <div className="en-content font-outfit-bold">
                  Something went wrong while loading the page. Please try again later.
                  <br /><br />
                  Have a question for Ben-sensei? Feel free to ask it <a href="/question" className="en-question-link">here!</a>
                </div>
                <div className="jp-content font-kleeone">
                  ページの読み込み中に問題が発生しました。しばらくしてからもう一度お試しください。
                  <br /><br />
                  ベン先生に質問がありますか？ ぜひ<a href="/question" className="jp-question-link">こちらから</a>質問してください！
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Articles;